module.exports = __webpack_public_path__ + "videos/selection_en.288a445.mp4";